type SellerFieldErrors = Record<string, string | undefined>;

/** Issue count per seller row, parsed from `sellers.<row>.<field>` error paths. */
export function countIssuesByRow(fieldErrors: SellerFieldErrors): Map<number, number> {
  const issuesByRow = new Map<number, number>();
  for (const [path, message] of Object.entries(fieldErrors)) {
    if (!message) continue;
    const row = rowOf(path);
    issuesByRow.set(row, (issuesByRow.get(row) ?? 0) + 1);
  }
  return issuesByRow;
}

export function findFirstIncompleteRow(fieldErrors: SellerFieldErrors): number | null {
  let first: number | null = null;
  for (const [path, message] of Object.entries(fieldErrors)) {
    if (!message) continue;
    const row = rowOf(path);
    if (first === null || row < first) first = row;
  }
  return first;
}

function rowOf(path: string): number {
  return Number(path.split('.')[1]);
}
